<!--菜单页-->
<template>
    <div class="mymenu" style="width:100%;height:100%;">
        <div style="height: 20px"></div>
        <div><h1>功能菜单</h1></div>
        <div style="height: 50px"></div>

        <div v-bind:style="{height:divHeight+'px'}" style="overflow-y: scroll;">
            <div v-if="admin || dev1 || operator || operator1 || installer || outsourcinginstaller">
                <van-button style="width: 80%" size="large" type="info" to="../jt808devices">JT808</van-button>
                <br>
            </div>
            <div v-if="admin || dev1 || operator1"><br>
                <van-button style="width: 80%" size="large" type="info" to="../siminfos">SIM卡管理</van-button>
                <br>
            </div>
            <div v-if="admin || installer"><br>
                <van-button style="width: 80%" size="large" type="info" to="../installersiminfos">我的SIM卡管理</van-button>
                <br>
            </div>
            <div v-if="admin || dev1 || operator || operator1 || installer"><br>
                <van-button style="width: 80%" size="large" type="info" to="../shortmessages">短信管理</van-button>
                <br>
            </div>
            <div v-if="admin || dev1 || installer"><br>
                <van-button style="width: 80%" size="large" type="info" to="../locatehistorys">历史数据查询</van-button>
                <br>
            </div>
            <div v-if="admin || operator || operator1 || other"><br>
                <a href="../usergroupinstallorder">
                    <van-button style="width: 80%" size="large" type="info" to="../usergroupinstallorder">团队安装订单</van-button>
                </a>
                <br>
            </div>
            <div v-if="admin || marketsales || operator || operator1"><br>
                <a href="../installorder">
                    <van-button style="width: 80%" size="large" type="info" to="../resalesman">我的安装订单</van-button>
                </a>
                <br>
            </div>
            <div v-if="admin || marketsales || operator || operator1"><br>
                <van-button style="width: 80%" size="large" type="info" to="../renewalorders">续费订单</van-button>
                <br>
            </div>
            <div v-if="admin || installer || outsourcinginstaller"><br>
                <a href="../installerinstallorder">
                    <!--                <a href="../installerinstallorder">-->
                    <van-button style="width: 80%" size="large" type="info" to="../setter">确认安装</van-button>
                </a>
                <br>
            </div>
            <!--     售后维修订单       -->
            <div v-if="admin || marketsales || operator || operator1 || other"><br>
                <van-button style="width: 80%" size="large" type="info" @click="tosalesmaintainOrders">团队维修订单
                </van-button>
                <br>
            </div>
            <!--     安装师傅维修订单       -->
            <div v-if="admin || installer"><br>
                <a href="../installermaintainorder">
                    <van-button style="width: 80%" size="large" type="info" to="../maintainOrders">确认维修
                    </van-button>
                </a>
                <br>
            </div>
            <div v-if="admin || client"><br>
                <van-button style="width: 80%" size="large" type="info" to="../attentioncar">重点关注车辆</van-button>
                <br>
            </div>
            <div v-if="admin || client"><br>
                <van-button style="width: 80%" size="large" type="info" to="../tracksintegrityanalysiss">轨迹完整分析
                </van-button>
                <br>
            </div>
            <div v-if="admin || operator || operator1"><br>
                <van-button style="width: 80%" size="large" type="info" to="../vehiclefreeinquire">保险免费资格
                </van-button>
                <br>
            </div>
            <div v-if="admin || dev1"><br>
                <van-button style="width: 80%" size="large" type="danger" @click="onDevelop">研发</van-button>
                <br>
            </div>
        </div>

        <div>
            <van-grid :column-num="2">
                <van-grid-item :text="'剩余安装订单数：'+ [installerodrer.installNum]" />
                <van-grid-item :text="'剩余维修订单数：'+ [installerodrer.maintainNum]" />
            </van-grid>
        </div>
        <div>
            <van-grid :column-num="2">
                <van-grid-item :text="'团队未安装订单数：'+ [installerodrer.groupinstallNum]" />
                <van-grid-item :text="'团队未维修订单数：'+ [installerodrer.groupmaintainNum]" />
            </van-grid>
        </div>


        <div style="width:100%;font-size: 15px;align-items: center;position:fixed;bottom: 58px;justify-content: center;">
            客服热线：0760-8888-0109（中山市）
        </div>
        <div style="width:100%;font-size: 15px;align-items: center;position:fixed;bottom: 38px;justify-content: center;">
            客服热线：0750-3310093（江门市）
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import store from '@/store'
    import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"


    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Grid,
        GridItem ,
    } from 'vant'

    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu).use(DropdownItem).use(Grid).use(GridItem)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem).use(DatetimePicker);

    export default {
        name: "myMenu",
        data() {
            return {
                roles: null,
                roleslist: [],
                admin: false,
                marketsales: false,
                installer: false,
                client: false,
                dev1: false,
                operator1: false,
                operator: false,
                outsourcinginstaller: false,

                other: false,

                divHeight: '',

                installerodrer:{
                    installNum:0,
                    groupinstallNum:0,
                    maintainNum:0,
                    groupmaintainNum:0,
                },
            }
        },
        methods: {
            onDevelop() {
                console.log('跳转')
                window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx35df9038a4f73847&redirect_uri=https%3a%2f%2fwxpa.jianchengjt.com%2fjumptodevelop&response_type=code&scope=snsapi_userinfo&state=1&connect_redirect=1#wechat_redirect'
            },

            //    跳转到维修订单
            tosalesmaintainOrders(){
                this.$router.push({
                    name: 'salesmaintainOrders',
                    params:{'getselfinfo':this.roleslist}
                })
            },
        },
        mounted() {
            if (window.innerHeight < 600) {
                this.divHeight = 320
            } else if (600 < window.innerHeight < 720) {
                this.divHeight = 420
            }

            store.dispatch('AccountServ_GetSelfInfo', {
                params: null,
                urlparams: null
            }).then((res) => {
                console.log(res)
                this.roles = res.data
                this.roleslist = res.data.roles
                if (res.data.id === 203 || res.data.id === 75) {
                    this.other = true
                }
                for (let i = 0; i < this.roleslist.length; i++) {
                    if (this.roleslist[i].name === 'admin') {
                        this.admin = true
                    }
                    if (this.roleslist[i].name === 'marketsales') {
                        this.marketsales = true
                    }
                    if (this.roleslist[i].name === 'installer') {
                        this.installer = true
                    }
                    if (this.roleslist[i].name === 'client') {
                        this.client = true
                    }
                    if (this.roleslist[i].name === 'dev1') {
                        this.dev1 = true
                    }
                    if (this.roleslist[i].name === 'operator1') {
                        this.operator1 = true
                    }
                    if (this.roleslist[i].name === 'operator') {
                        this.operator = true
                    }
                    if (this.roleslist[i].name === 'outsourcinginstaller'){
                        this.outsourcinginstaller = true
                    }
                }
            })
                .catch((err) => {
                    console.log(err)
                })

            store.dispatch('InstallOrderServ_GetMyNotInstallNum',{
                params:null,
                urlparams:null
            }).then((res)=>{
                // console.log(res)
                this.installerodrer.installNum = res.data
            }).catch((err)=>{
                console.log(err)
            })

            store.dispatch('InstallOrderServ_GetMyGroupNotInstallNum',{
                params:null,
                urlparams:null
            }).then((res)=>{
                // console.log(store.getters.get_InstallOrder_GetMyGroupNotInstallNumResult)
                store.getters.get_InstallOrder_GetMyGroupNotInstallNumResult.forEach(item=>{
                    if (item.length>0 && item[0].userGroupId != null) {
                        if (item[0].userGroupId === this.roles.userGroupId) {
                            // console.log(item.length)
                            this.installerodrer.groupinstallNum += item.length
                        }
                    }
                })
                // this.installerodrer.groupinstallNum = store.getters.get_InstallOrder_GetMyGroupNotInstallNumResult
            }).catch((err)=>{
                console.log(err)
            })

            store.dispatch('MaintainOrderServ_GetMyNotMaintainNum',{
                params:null,
                urlparams:null
            }).then((res)=>{
                // console.log(res)
                this.installerodrer.maintainNum = res.data
            }).catch((err)=>{
                console.log(err)
            })

            store.dispatch('MaintainOrderServ_GetMyGroupNotMaintainNum',{
                params:null,
                urlparams:null
            }).then((res)=>{
                // console.log(store.getters.get_MaintainOrder_GetMyGroupNotMaintainNumResult)
                store.getters.get_MaintainOrder_GetMyGroupNotMaintainNumResult.forEach(item=>{
                    if (item.length>0 && item[0].userGroupId != null) {
                        if (item[0].userGroupId === this.roles.userGroupId) {
                            // console.log(item.length)
                            this.installerodrer.groupmaintainNum += item.length
                        }
                    }
                })
                // this.installerodrer.groupmaintainNum = store.getters.get_MaintainOrder_GetMyGroupNotMaintainNumResult
            }).catch((err)=>{
                console.log(err)
            })
        }
    }
</script>

<style scoped>
    .mymenu {
        text-align: center;
    }
</style>
